import logoSvg from "../../assets/logo.svg";

export function FooterSection() {
  return (
    <footer className="border-t border-ink-100 bg-white">
      <div className="mx-auto flex max-w-[1200px] flex-col items-center justify-between gap-6 px-6 py-10 md:flex-row md:items-start">
        <div className="flex items-center">
          <img alt="スカウトメールAI" className="h-6" src={logoSvg} />
        </div>
        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-[12px] text-ink-600">
          <a href="#flow">機能</a>
          <a href="#pricing">料金</a>
          <a href="#cases">導入事例</a>
          <a href="/support">サポート</a>
          <a href="/privacy-policy">プライバシーポリシー</a>
          <a href="/terms">利用規約</a>
          <a href="/tokushoho">特定商取引法に基づく表記</a>
        </nav>
        <div className="flex items-center gap-3 text-ink-400">
          <button aria-label="Web" className="hover:text-ink-700" type="button">
            <span className="mi text-[18px]">language</span>
          </button>
          <button aria-label="Network" className="hover:text-ink-700" type="button">
            <span className="mi text-[18px]">hub</span>
          </button>
          <button aria-label="X" className="hover:text-ink-700" type="button">
            <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <title>X</title>
              <path d="M17.53 3H21l-7.5 8.57L22 21h-6.78l-5.3-6.93L3.78 21H.31l8.04-9.18L1 3h6.94l4.79 6.33L17.53 3Zm-1.19 16.2h2L7.78 4.7h-2.1l10.66 14.5Z" />
            </svg>
          </button>
        </div>
      </div>
      <div className="border-t border-ink-100 py-4 text-center text-[11px] text-ink-400">
        © 2024 Snack, Inc.
      </div>
    </footer>
  );
}
